// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-image-view[data-v-0d781ce1]{padding:0 0 .3125rem 0;width:100%}.video-image-view .video-photo[data-v-0d781ce1]{width:100%}", ""]);
// Exports
module.exports = exports;
